import React, {Component} from 'react';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import "../common.css"
import "./index.css"
import * as _ from 'lodash'
import {Button, Col, Container, CustomInput, Row} from "reactstrap";
import {Field, formValueSelector, reduxForm, submit} from "redux-form";
import {connect} from "react-redux";
import classNames from "classnames";
import Autocomplete from '@celebryts/react-autocomplete-tags'
import * as actions from "../../../../actions";
import {isFileImage, required, vuepayAlert} from "../../../../util/utility";
import formEl from "../../../../util/form";
import assets from "../../../../util/assets";
import api from "../../../../util/clipstore/broadcaster/library";
import util from "../../../../util/clipstore/broadcaster/create";
import {VideoPlayer} from "../../../../components/clipstore/broadcaster/library/video-player";
import {UploadFileModal} from "../../../../components/modal/clipstore/broadcaster/UploadFileModal";

class CreateVideoContentPage extends Component {

    constructor() {
        super();

        this.state = {
            title: '',
            count: 0,
            titleCount: 0,
            suggestions: [],
            currentVideoId: null,
            currentVideo: null,
            signedURL: '',
            uploadContent: false,
            duration: 0,
            extension: 0,
            thumbnailImage: null,
            videoJsOptions: {
                fluid: true,
                autoplay: false,
                controls: true,
                // poster:props.video.thumbnail_url,
                sources: [{
                    src: null,
                    type: "video/mp4"
                }],
                aspectRatio: "16:9"
            },
            tagsArray: [],
            tags: [],
            content: {
                payload: null
            },
            id: "",
            imageSrc: null,

            fromMessageScreen: false,
            isPartOfLibrary: true,
            contentForMessage: null
        };


        //all the functions used in this component should be listed here for better documentation
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    componentDidMount() {
        api.getPredefinedTagsAPI(this.props);


        if (this.props.upload_video_content &&
            this.props.upload_video_content.hasOwnProperty("payload") &&
            this.props.upload_video_content.payload === null) {
            this.setUploadContent(true);
        } else {
            this.setVideoJsOptions(this.props.upload_video_content.payload);
        }

        if (this.props.location && this.props.location.hasOwnProperty("state") && this.props.location.state && this.props.location.state.hasOwnProperty("fromMessageScreen")) {
            this.setState({
                fromMessageScreen: this.props.location.state.fromMessageScreen,
                selectedChannel: this.props.location.state.selectedChannel,
            })
        }
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.add_edit_pricing_content && nextProps.add_edit_pricing_content.payload !== this.state.content.payload) {

            let tags = nextProps.add_edit_pricing_content.payload && nextProps.add_edit_pricing_content.payload.tags;
            let autocompleteTagsArray = [], tagsValueArray = [];
            tags.map((tag) => {
                autocompleteTagsArray.push({
                    label: tag.name,
                    value: tag.name,
                })

                tagsValueArray.push(tag.name)
            })


            this.setState({
                content: nextProps.add_edit_pricing_content,
                id: nextProps.add_edit_pricing_content.payload && nextProps.add_edit_pricing_content.payload.id,
                tagsArray: autocompleteTagsArray,
                tags: tagsValueArray,
                titleCount:nextProps.add_edit_pricing_content.payload && nextProps.add_edit_pricing_content.payload.title.length,
                count:nextProps.add_edit_pricing_content.payload && nextProps.add_edit_pricing_content.payload.description.length,
            })
        }

        if (this.props.upload_video_content.payload !== nextProps.upload_video_content.payload) {
            this.setVideoJsOptions(nextProps.upload_video_content.payload);
        }

        //handle the API response for publishing the videos
        api.handleAPIResponse(nextProps, "add_video_to_library", () => {
            //reset the payload value as we have captured the event
        }, () => {

            this.setState({
                contentForMessage: nextProps.add_video_to_library.payload.success.data
            }, () => {
                if (this.state.imageSrc === null) {
                    this.setCurrentVideoId(nextProps.add_video_to_library.payload.success.data.id);
                    this.setSignedURL(nextProps.add_video_to_library.payload.success.data.url);
                } else {
                    this.props.resetAddVideoToLibrary();
                    this.goBack();
                }
            });
        }, () => {
            //nothing to handle
            this.props.resetAddVideoToLibrary();
        })


        if (nextProps.predefinedTags &&
            nextProps.predefinedTags.payload !== null) {

            let tags = [];
            if (nextProps.predefinedTags.payload && Array.isArray(nextProps.predefinedTags.payload)) {
                nextProps.predefinedTags.payload.map((tag) => {
                    tags.push({
                        label: tag.name,
                        value: tag.name,
                    })
                })
            }

            this.setState({
                suggestions: tags
            })
        }

        //handle the API response for publishing the videos
        api.handleAPIResponse(nextProps, "edit_video_to_gallery", () => {
            //reset the payload value as we have captured the event
            this.props.resetEditVideoToLibrary();
        }, () => {
            this.props.toggle("refresh")
        }, () => {
            //nothing to handle
        })
    }

    setVideoJsOptions = (file) => {

        const blob = URL.createObjectURL(file);

        if (isFileImage(file)) {
            this.setState({
                imageSrc: blob,
                extension: file.name.split('.').pop(),
                thumbnailImage: file
            }, () => {
                this.setUploadContent(false);
            })
        } else {
            this.setState({
                videoJsOptions: {
                    fluid: true,
                    autoplay: false,
                    controls: true,
                    // poster:props.video.thumbnail_url,
                    sources: [{
                        src: blob,
                        type: file.type
                    }],
                    aspectRatio: "16:9"
                },
                extension: file.name.split('.').pop()
            }, () => {
                let ref = this;
                this.setUploadContent(false);
                util.getThumbnail(file, (thumbnailImage) => {
                    ref.setState({
                        thumbnailImage
                    })
                });
                util.getDuration(blob, (duration) => {
                    ref.setState({
                        duration
                    })
                });
            })
        }

    }

    goBack = () => {

        if (this.state.fromMessageScreen) {

            this.props.history.push({
                pathname: '/broadcaster/messaging',
                state: {
                    selectedChannel: this.state.selectedChannel,
                    content: this.state.contentForMessage
                }
            });
        } else {
            this.props.history.push("/broadcaster/my-library");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }

    }

    setSignedURL = (url) => {
        this.setState({
            signedURL: url
        })
    }

    resetSignedURL = () => {
        this.setSignedURL("");
        this.setUploadContent(false);
    }

    setUploadContent = (uploadContent) => {
        this.setState({
            uploadContent
        }, () => {
            if (!uploadContent && this.state.videoJsOptions.sources[0].src === null) {
                if (this.state.imageSrc === null) {
                    vuepayAlert("error", "Sorry, no video/picture content found", () => {
                        this.goBack();
                    })
                }
            }
        })
    }

    setCurrentVideoId = (id) => {
        this.setState({
            currentVideoId: id
        })
    }

    resetCurrentVideoId = () => {
        this.setCurrentVideoId(null);
    }

    onKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); //<===== This stops the form from being submitted
        }
    }

    onSubmit(values) {

        if (this.state.id === "") {
            const formData = new FormData();
            formData.append("title", values.title);
            formData.append("description", values.description);
            formData.append("tags[]", this.state.tags);
            formData.append("age_group", values.age_group);
            formData.append("duration", this.state.duration);
            formData.append("extension", this.state.extension);
            formData.append("thumbnail", this.state.thumbnailImage);
            formData.append("is_part_of_my_library", this.state.isPartOfLibrary);

            formData.append("device[platform]", this.props.device.platform);
            formData.append("device[name]", this.props.device.name);
            formData.append("device[version]", this.props.device.version);
            formData.append("device[ip]", this.props.device.ip);
            formData.append("device[id]", this.props.device.id);
            formData.append("device[app_version]", this.props.device.app_version);
            formData.append("device[device_token]", this.props.device.device_token);


            if (this.state.imageSrc === null) {
                api.addVideoToLibraryAPI(this.props, formData);
            } else {
                api.addPictureToLibraryAPI(this.props, formData);
            }
        } else {
            let editData = {
                title: values.title,
                description: values.description,
                tags: this.state.tags,
                age_group: values.age_group,
                device: {
                    platform: this.props.device.platform,
                    name: this.props.device.name,
                    version: this.props.device.version,
                    ip: this.props.device.ip,
                    id: this.props.device.id,
                    app_version: this.props.device.app_version,
                    device_token: this.props.device.device_token,
                }
            }


            if (this.state.content.payload.type === "picture") {
                api.editPictureToLibraryAPI(this.props, this.state.id, editData);
            } else {
                api.editVideoToLibraryAPI(this.props, this.state.id, editData);
            }
        }
    }

    onCancel() {
        if(this.state.id === ""){
            this.props.history.push("/broadcaster/my-library")
        }else{
            this.props.toggle()
        }
    }

    handleChange(value) {
    }

    onAdd(value) {

        let tagsArray = this.state.tags;
        tagsArray.push(value.label);

        let duplicate = false;
        tagsArray = tagsArray.reduce((unique, item) => {
            if (unique.includes(item)) {
                duplicate = true;
                return unique;
            } else {
                return [...unique, item];
            }
        }, []);

        setTimeout(() => {
            if (duplicate) {
                let theme_tag__25f = document.getElementsByClassName("theme_tag__25f");
                let length = theme_tag__25f.length;
                theme_tag__25f[length - 1].remove();
            }
        }, 1000);

        this.setState({
            tags: tagsArray
        }, () => {
        })
    }

    onDelete(value) {

        let arr = this.state.tags;
        _.remove(arr, function (e) {
            return e === value[0];
        });

        this.setState({
            tags: arr
        }, () => {
        })
    }


    onKeyUp(e) {

    }

    onSave() {
        setTimeout(() => {
            this.props.dispatch(submit('CreateVideoContentForm'))
        }, 100)
    }

    onChange = (value) => {
    }

    handleOnBlur(event, newValue, previousValue, name) {
        /**
         * setTimeout is needed so that the dispatch can be called
         * */
        setTimeout(() => {
            const newData = util.filterProfanity(this.props, name, newValue);
            this.setState({
                title: newData,
                titleCount: newData.length,
            });
        }, 0);
    };

    textAreaChange(event, newValue, previousValue, name) {
        /**
         * setTimeout is needed so that the dispatch can be called
         * */
        setTimeout(() => {
            const newData = util.filterProfanity(this.props, name, newValue);
            this.setState({
                count: newData.length,
            })
        }, 0);
    }

    render() {
        const {handleSubmit} = this.props;
        const parentContainer = classNames({
            "broadcast-container-parent": !this.props.hasOwnProperty("editMode"),
            "row": !this.props.hasOwnProperty("editMode"),
        })

        const broadcastContainer = classNames({
            "broadcast-container": !this.props.hasOwnProperty("editMode"),
            "other-middle-container": !this.props.hasOwnProperty("editMode"),
        })

        const myLibraryHomeContainer = classNames("no-padding", {
            "my-library-home-container": !this.props.hasOwnProperty("editMode"),
        })

        const formContainer = classNames({
            "edit-video-form": this.props.hasOwnProperty("editMode"),
        })
        return (
            <main role="main" className="">
                <div className={parentContainer}>
                    <div className={broadcastContainer}>

                        {
                            !this.props.hasOwnProperty("editMode") &&
                            <UploadFileModal
                                history={this.props.history}
                                isOpen={(this.state.uploadContent || this.state.signedURL !== '')}
                                file={this.props.upload_video_content.payload}
                                toggle={this.resetSignedURL}
                                uploadContent={this.state.uploadContent}
                                signedURL={this.state.signedURL}
                                currentVideo={{
                                    title: this.state.title
                                }}
                                onError={(message) => {
                                    api.onErrorUpload(this.props, this.state.currentVideoId)
                                }}
                                onFinish={(signResult) => {
                                    api.onFinishUpload(this.props, signResult, this.goBack)
                                }}
                                setVideoContent={this.props.setVideoContent}
                            />
                        }

                        <Container className={myLibraryHomeContainer}>
                            {
                                !this.props.hasOwnProperty("editMode") &&
                                <Row className="display-flex-vertical-center no-margin border-bottom"
                                     style={{padding: 16}}>
                                    <Col sm="12" className="my-library-title no-padding text-align-left ">Create</Col>
                                </Row>
                            }


                            <div className="wrapper">

                                {
                                    !this.props.hasOwnProperty("editMode") &&
                                    <div className="form-group text-align-center">
                                        {
                                            this.state.videoJsOptions.sources[0].src !== null &&
                                            <VideoPlayer {...this.state.videoJsOptions} />
                                        }
                                        {
                                            this.state.imageSrc !== null &&
                                            <Zoom>
                                                <img
                                                    alt="thumbnail"
                                                    src={this.state.imageSrc}
                                                    height="200"
                                                />
                                            </Zoom>
                                        }
                                    </div>
                                }

                                <form onSubmit={handleSubmit(this.onSubmit.bind(this))} onKeyPress={this.onKeyPress}
                                      className={formContainer}>
                                    <div>

                                        {/*Enter session title*/}
                                        <Field
                                            label="Title"
                                            name="title"
                                            placeholder="Please enter title here..."
                                            type="text"
                                            maxLength="40"
                                            count={this.state.titleCount}
                                            onBlur={this.handleOnBlur}
                                            onChange={this.handleOnBlur}
                                            height={"49px"}
                                            validate={[required]}
                                            component={formEl.renderInputField}
                                        />
                                        {/*Enter session title*/}

                                        {/*Enter session description*/}
                                        <Field
                                            label="Description"
                                            name="description"
                                            placeholder="Please enter description here..."
                                            maxLength="280"
                                            minLength="1"
                                            onBlur={this.textAreaChange}
                                            height={"153px"}
                                            count={this.state.count}
                                            validate={[required]}
                                            component={formEl.renderTextAreaField}
                                            onChange={this.textAreaChange}
                                        />
                                        {/*Enter session description*/}

                                        {
                                            this.state.fromMessageScreen &&
                                            <div className="form-group">
                                                <div className="display-flex-align-center">
                                                    <CustomInput
                                                        type="checkbox"
                                                        id={`part-of-library`}
                                                        name={`part-of-library`}
                                                        value={this.state.isPartOfLibrary}
                                                        onChange={() => {
                                                            this.setState({
                                                                isPartOfLibrary: !this.state.isPartOfLibrary
                                                            })
                                                        }}
                                                    />
                                                    <span className="label-14" style={{marginBottom: 0}}>Add to My Library</span>
                                                </div>
                                            </div>
                                        }


                                        {/*Age rating*/}
                                        <div>
                                            <label className="custom-form-label">
                                                Age rating
                                                <a href="https://www.bbfc.co.uk/about-classification/classification-guidelines"
                                                   target="_blank">
                                                    <img alt={"close-icon"} width="18" src={assets.information}/>
                                                </a>
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="ageGroup">
                                                <Field
                                                    name="age_group"
                                                    component="input"
                                                    type="radio"
                                                    validate={[required]}
                                                    value="less_than_12"
                                                />{" "}
                                                Under 12
                                            </label>
                                            <label className="ageGroup">
                                                <Field
                                                    name="age_group"
                                                    component="input"
                                                    type="radio"
                                                    validate={[required]}
                                                    value="more_than_12"
                                                />{" "}
                                                12+
                                            </label>
                                            <label className="ageGroup">
                                                <Field
                                                    name="age_group"
                                                    component="input"
                                                    type="radio"
                                                    validate={[required]}
                                                    value="more_than_15"
                                                />{" "}
                                                15+
                                            </label>
                                            <label className="ageGroup">
                                                <Field
                                                    name="age_group"
                                                    component="input"
                                                    type="radio"
                                                    validate={[required]}
                                                    value="18"
                                                />{" "}
                                                18
                                            </label>
                                        </div>
                                        {/*Age rating*/}

                                        <div className="form-group">
                                            <label className="custom-form-label">Content tags</label>
                                            <Autocomplete
                                                className="my-css-class"
                                                placeholder="Add your tags here..."
                                                suggestions={this.state.suggestions}
                                                validate={[required]}
                                                onChange={this.handleChange}
                                                onKeyUp={this.onKeyUp}
                                                onKeyDown={this.onKeyDown}
                                                onAdd={this.onAdd}
                                                onDelete={this.onDelete}
                                                tags={this.state.tagsArray}
                                            />
                                        </div>

                                    </div>

                                    <Row className="display-flex-vertical-center no-margin button-container">
                                        {
                                            !this.props.hasOwnProperty("editMode") &&
                                            <Col sm="6" className="my-library-title no-padding text-align-left"/>
                                        }
                                        <Col sm={this.props.hasOwnProperty("editMode") ? "12" : "6"}
                                             className="no-padding  text-align-right">
                                            <Button color="outline-secondary" onClick={this.onCancel}>
                                                CANCEL
                                            </Button>

                                            <Button color="primary">
                                                {
                                                    (this.props.add_video_to_library.isFetching || this.props.edit_video_to_gallery.isFetching)
                                                        ?
                                                        <img
                                                            src={assets.loading_white}
                                                            alt={"Loading"}
                                                            width={26}
                                                            height={26}
                                                        />
                                                        :
                                                        "SAVE CHANGES"
                                                }

                                            </Button>
                                        </Col>
                                    </Row>
                                </form>
                            </div>


                        </Container>
                    </div>
                </div>
            </main>
        );
    }
}

function mapStateToProps(state) {

    const selector = formValueSelector("CreateVideoContentForm");
    const payload = state.clipstore_broadcaster_add_edit_pricing_content.payload;

    return {
        initialValues: {
            title: payload && payload.title,
            description: payload && payload.description,
            age_group: payload && payload.age_group,
        },
        account_management: state.account_management,
        device: state.device.payload,
        profanity: state.profanity.words,
        predefinedTags: state.predefinedTags,
        upload_video_content: state.clipstore_broadcaster_upload_video_content,
        add_video_to_library: state.clipstore_broadcaster_add_video_to_library,
        edit_video_to_gallery: state.clipstore_broadcaster_edit_video_to_gallery,
        add_edit_pricing_content: state.clipstore_broadcaster_add_edit_pricing_content,
    }
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
CreateVideoContentPage = reduxForm({
    form: "CreateVideoContentForm", // a unique identifier for this form
    enableReinitialize: true,
})(CreateVideoContentPage);

// You have to connect() to any reducers that you wish to connect to yourself
CreateVideoContentPage = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(CreateVideoContentPage);

export default CreateVideoContentPage;